'use strict';

var RecommendationCompetitorPanelDirective = function RecommendationCompetitorPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'RecommendationCompetitorPanelController',
    template: require('../templates/recommendation-competitor-panel.html'),
    scope: {
      screenState: '=',
      dataDimension: '=dimension'
    }
  };
};
RecommendationCompetitorPanelDirective.$inject = [];
module.exports = RecommendationCompetitorPanelDirective;